import { render, staticRenderFns } from "./veSbzcZcApplyEdit.vue?vue&type=template&id=882b99e4&scoped=true"
import script from "./veSbzcZcApplyEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcApplyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882b99e4",
  null
  
)

export default component.exports